'use strict';

import './play-embedded';
import './player-dialog';